import Translations from 'src/core/utils/Translations';
import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import { useHeaderStyle, useModalHeaderStyle } from 'src/presentation/hooks/useHeaderStyle';
import { useActiveLanguage } from 'src/presentation/hooks/useActiveLanguage';
import {
	headerCloseButtonOnImage,
	headerlessStackScreenOptions,
	transparentHeaderScreenOptions,
} from 'src/presentation/navigation/defaultScreenOptions';
import type { HomeNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import HomeScreen from 'src/presentation/screens/HomeScreen';
import ResortScreen from 'src/presentation/screens/ResortScreen';

const Stack = createStackNavigator<HomeNavigation>();

export default function HomeStackNavigator() {
	useActiveLanguage();

	const headerStyle = useHeaderStyle();
	const modalHeaderStyle = useModalHeaderStyle();

	const detailScreenOptions = ({ navigation }: { navigation: { goBack: () => void } }) => ({
		...transparentHeaderScreenOptions,
		presentation: 'modal' as const,
		headerStyle: modalHeaderStyle,
		headerLeft: () => null,
		headerRight: () => headerCloseButtonOnImage({ navigation }),
	});

	return (
		<Stack.Navigator screenOptions={{ ...headerlessStackScreenOptions, headerTitle: Translations.book }}>
			<Stack.Screen
				component={HomeScreen}
				name={Constants.screenHome}
				options={{ ...transparentHeaderScreenOptions, headerStyle }}
			/>
			<Stack.Screen component={ResortScreen} name={Constants.screenResort} options={detailScreenOptions} />
		</Stack.Navigator>
	);
}
